// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Analytics tab — Paper Dashboard look & feel, scoped under .an-root so
   nothing leaks into the rest of the app.
   Palette: primary #51cbce, info #51bcda, success #6bd098, warning #fbc658,
   danger #ef8157, text #252422 / #66615b, muted #9a9a9a, border #e3e3e3.
   ========================================================================== */

/* The whole tab scrolls as one page (like Interview / Questions). */
.an-root {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 4px 6px 12px;
    text-align: left;
}

/* Layout helpers the sub-tabs use */
.an-root .q-col-flex { display: flex; flex-direction: column; min-height: 0; }
.an-root .q-fill { flex: 1 1; min-height: 0; }
.an-root .q-no-x { overflow-x: hidden; }
.an-root .q-card-fill { height: 100%; }
.an-root .q-card-body-scroll { overflow: visible; }

/* ---------- Sub-tabs (Overview / Candidates / Steps / …) as pills ---------- */
.an-root .analytics-tabs {
    border-bottom: none;
    gap: 6px;
    flex-wrap: wrap;
}

.an-root .analytics-tabs .nav-item {
    margin-bottom: 0;
}

.an-root .analytics-tabs .analytics-tablink {
    border: 1px solid #e3e3e3 !important;
    border-radius: 999px !important;
    padding: 6px 16px;
    margin-right: 0;
    color: #66615b;
    font-size: 13px;
    font-weight: 600;
    background: #fff;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: background .15s ease, color .15s ease, border-color .15s ease;
}

.an-root .analytics-tabs .analytics-tablink:hover {
    border-color: #51cbce !important;
    color: #51cbce;
}

.an-root .analytics-tabs .analytics-tablink.active {
    background: #51cbce !important;
    border-color: #51cbce !important;
    color: #fff !important;
}

/* ---------- Scope bar ---------- */
.an-root .analytics-scope-bar {
    margin-top: 10px;
}

.an-root .analytics-scope-label {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.an-root .analytics-scope-title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: #9a9a9a;
}

.an-root .analytics-scope-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 999px;
    background: rgba(81, 203, 206, .15);
    color: #1f7f82;
    font-size: 13px;
    font-weight: 600;
}

.an-root .analytics-scope-breadcrumb {
    font-weight: 400;
    color: #3aa9ac;
}

.an-root .analytics-scope-breadcrumb::before {
    content: "·";
    margin: 0 6px 0 2px;
}

.an-root .analytics-scope-reset {
    padding: 2px 6px;
    font-size: 12px;
    color: #9a9a9a;
    text-transform: none;
}

.an-root .analytics-scope-reset:hover {
    color: #ef8157;
    text-decoration: none;
}

.an-root .analytics-scope-reset.is-disabled,
.an-root .analytics-scope-reset:disabled {
    opacity: .45;
    cursor: not-allowed;
    pointer-events: none;
}

/* ---------- Cards ---------- */
.an-root .card {
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    box-shadow: none !important;
    margin-bottom: 0;
}

/* The outer wrapper cards only group content: keep them flat */
.an-root .q-card-fill {
    border: none;
    background: transparent;
}

.an-root .q-card-fill > .card-body,
.an-root .q-card-fill > div:first-child {
    padding-left: 0;
    padding-right: 0;
}

.an-root .card .card-body {
    padding: 14px 16px;
}

.an-root .metric-number {
    display: block;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.2;
    color: #252422;
    margin-top: 4px;
}

.an-root .kpi-title { font-size: 12px; color: #9a9a9a; }
.an-root .kpi-value { font-size: 1.6rem; font-weight: 700; color: #252422; }
.an-root .kpi-sub { font-size: 12px; color: #9a9a9a; margin-top: 4px; }
.an-root .section-title { font-weight: 600; margin-bottom: 8px; color: #252422; }

.an-root .list-group-item {
    padding: 8px 4px;
    border-color: #f0f0f0;
    font-size: 13.5px;
    color: #252422;
}

.an-root .list-group-item strong {
    color: #3aa9ac;
}

.an-root .form-select,
.an-root select.form-select-sm {
    border: 1px solid #dddddd;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 13px;
    color: #66615b;
    background: #fff;
}

/* ---------- Selectable rows (steps, questions, skills, candidates) ---------- */
.an-root .btn.an-item {
    display: block;
    margin: 0 0 6px 0 !important;
    padding: 9px 12px;
    text-transform: none;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0;
    border-radius: 6px !important;
    background: #fff !important;
    color: #252422 !important;
    border: 1px solid #ececec !important;
    border-left: 3px solid transparent !important;
    box-shadow: none !important;
    white-space: normal;
}

.an-root .btn.an-item:hover,
.an-root .btn.an-item:focus {
    background: #f7fdfd !important;
    border-color: #cfeff0 !important;
}

.an-root .btn.an-item.is-active {
    background: rgba(81, 203, 206, .12) !important;
    border-color: #51cbce !important;
    border-left-color: #51cbce !important;
    font-weight: 600;
}

/* ---------- Pills ---------- */
.an-root .an-pill {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 999px;
    background: #f1f1f1;
    color: #66615b;
    white-space: nowrap;
}

.an-root .an-pill--score { background: rgba(81, 203, 206, .15); color: #1f7f82; }
.an-root .an-pill--pending { background: #fff4d6; color: #8a6100; }
.an-root .an-pill--approved { background: #dcf5e7; color: #1e7e4a; }
.an-root .an-pill--rejected { background: #fde3da; color: #b3461f; }
.an-root .an-pill--hired { background: #dff3f9; color: #1b6f87; }

/* Bootstrap-5 style badges used in a few places */
.an-root .badge.bg-success { background: #6bd098 !important; }
.an-root .badge.bg-secondary { background: #fbc658 !important; color: #5c4400 !important; }

/* ---------- Empty states ---------- */
.an-root .an-empty {
    text-align: center;
    color: #9a9a9a;
    padding: 28px 12px;
    font-size: 13px;
    border: 1px dashed #dddddd;
    border-radius: 8px;
}

/* ---------- Utilities used by the sub-tabs ---------- */
.an-root .gap-8 { gap: 8px; }
.an-root .gap-12 { gap: 12px; }
.an-root .mb-6 { margin-bottom: 6px; }
.an-root .fs-10 { font-size: 10px; }
.an-root .fs-12 { font-size: 12px; }
.an-root .fw-600 { font-weight: 600; }
.an-root .fw-700 { font-weight: 700; }
.an-root .op-60 { opacity: .6; }
.an-root .op-70 { opacity: .7; }

/* ---------- CandidatesTab ---------- */
.an-root .ct-card-body { display: flex; flex-direction: column; gap: 12px; height: 100%; }
.an-root .cand-list {
    max-height: 320px;
    overflow: auto;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 8px;
}

/* ---------- Histogram (class-based variant) ---------- */
.an-root .hist-wrap { height: 150px; display: flex; align-items: flex-end; gap: 8px; padding: 8px 4px; }
.an-root .hist-col { flex: 1 1; display: flex; flex-direction: column; align-items: center; gap: 4px; }
.an-root .hist-bar-container { width: 100%; height: 120px; display: flex; align-items: flex-end; }
.an-root .hist-bar {
    width: 100%;
    height: 0%;
    height: var(--h, 0%);
    background: #51cbce;
    border-radius: 4px;
    transition: height .3s ease;
}
.an-root .hist-label { font-size: 10px; white-space: nowrap; }

/* ---------- DepartmentsSidebar ---------- */
.an-root .sidebar-header-title { font-weight: 600; }
.an-root .sidebar-stack { display: flex; flex-direction: column; gap: 8px; }
.an-root .sidebar-btn { border-radius: 6px; }

/* ---------- Selectable list (SkillsTab) ---------- */
.an-root .selectable-list .list-group-item {
    border: 1px solid #ececec;
    margin-bottom: 6px;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    transition: background .15s ease;
}
.an-root .selectable-list .list-group-item:hover { background: #f7fdfd; }
.an-root .selectable-list .list-group-item.active {
    background: rgba(81, 203, 206, .12) !important;
    border-color: #51cbce !important;
    color: #252422 !important;
    font-weight: 600;
}

/* Bootstrap 4 has no "g-3" gutters: give the card grids vertical spacing */
.an-root .row.g-3 > [class*="col"] {
    margin-bottom: 16px;
}

/* KPI labels never break inside a word */
.an-root .card-body > div:first-child {
    overflow-wrap: normal;
    word-break: normal;
}
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Analytics/Analytics.css"],"names":[],"mappings":"AAAA;;;;;+EAK+E;;AAE/E,oEAAoE;AACpE;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,aAAa,EAAE;AAC7E,mBAAmB,SAAO,EAAE,aAAa,EAAE;AAC3C,mBAAmB,kBAAkB,EAAE;AACvC,wBAAwB,YAAY,EAAE;AACtC,+BAA+B,iBAAiB,EAAE;;AAElD,gFAAgF;AAChF;IACI,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,yEAAyE;AAC7E;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,oCAAoC;AACpC;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,mCAAmC;IACnC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,gCAAgC;AAChC;IACI,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,+DAA+D;AAC/D;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,sBAAsB,eAAe,EAAE,cAAc,EAAE;AACvD,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3E,oBAAoB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACtE,0BAA0B,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAEhF;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,iFAAiF;AACjF;IACI,cAAc;IACd,4BAA4B;IAC5B,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;IACzB,oCAAoC;IACpC,6CAA6C;IAC7C,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,8CAA8C;IAC9C,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA,2BAA2B,mCAAmC,EAAE,cAAc,EAAE;AAChF,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,kDAAkD;AAClD,6BAA6B,8BAA8B,EAAE;AAC7D,+BAA+B,8BAA8B,EAAE,yBAAyB,EAAE;;AAE1F,uCAAuC;AACvC;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD,kBAAkB,QAAQ,EAAE;AAC5B,mBAAmB,SAAS,EAAE;AAC9B,iBAAiB,kBAAkB,EAAE;AACrC,kBAAkB,eAAe,EAAE;AACnC,kBAAkB,eAAe,EAAE;AACnC,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,gBAAgB,EAAE;AACrC,kBAAkB,WAAW,EAAE;AAC/B,kBAAkB,WAAW,EAAE;;AAE/B,wCAAwC;AACxC,yBAAyB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,YAAY,EAAE;AACzF;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,0DAA0D;AAC1D,sBAAsB,aAAa,EAAE,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACvG,qBAAqB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACpG,+BAA+B,WAAW,EAAE,aAAa,EAAE,aAAa,EAAE,qBAAqB,EAAE;AACjG;IACI,WAAW;IACX,UAAoB;IAApB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA,uBAAuB,eAAe,EAAE,mBAAmB,EAAE;;AAE7D,6CAA6C;AAC7C,iCAAiC,gBAAgB,EAAE;AACnD,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3E,wBAAwB,kBAAkB,EAAE;;AAE5C,sDAAsD;AACtD;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;AACA,mDAAmD,mBAAmB,EAAE;AACxE;IACI,8CAA8C;IAC9C,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,2EAA2E;AAC3E;IACI,mBAAmB;AACvB;;AAEA,yCAAyC;AACzC;IACI,qBAAqB;IACrB,kBAAkB;AACtB","sourcesContent":["/* ==========================================================================\n   Analytics tab — Paper Dashboard look & feel, scoped under .an-root so\n   nothing leaks into the rest of the app.\n   Palette: primary #51cbce, info #51bcda, success #6bd098, warning #fbc658,\n   danger #ef8157, text #252422 / #66615b, muted #9a9a9a, border #e3e3e3.\n   ========================================================================== */\n\n/* The whole tab scrolls as one page (like Interview / Questions). */\n.an-root {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 4px 6px 12px;\n    text-align: left;\n}\n\n/* Layout helpers the sub-tabs use */\n.an-root .q-col-flex { display: flex; flex-direction: column; min-height: 0; }\n.an-root .q-fill { flex: 1; min-height: 0; }\n.an-root .q-no-x { overflow-x: hidden; }\n.an-root .q-card-fill { height: 100%; }\n.an-root .q-card-body-scroll { overflow: visible; }\n\n/* ---------- Sub-tabs (Overview / Candidates / Steps / …) as pills ---------- */\n.an-root .analytics-tabs {\n    border-bottom: none;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.an-root .analytics-tabs .nav-item {\n    margin-bottom: 0;\n}\n\n.an-root .analytics-tabs .analytics-tablink {\n    border: 1px solid #e3e3e3 !important;\n    border-radius: 999px !important;\n    padding: 6px 16px;\n    margin-right: 0;\n    color: #66615b;\n    font-size: 13px;\n    font-weight: 600;\n    background: #fff;\n    cursor: pointer;\n    user-select: none;\n    transition: background .15s ease, color .15s ease, border-color .15s ease;\n}\n\n.an-root .analytics-tabs .analytics-tablink:hover {\n    border-color: #51cbce !important;\n    color: #51cbce;\n}\n\n.an-root .analytics-tabs .analytics-tablink.active {\n    background: #51cbce !important;\n    border-color: #51cbce !important;\n    color: #fff !important;\n}\n\n/* ---------- Scope bar ---------- */\n.an-root .analytics-scope-bar {\n    margin-top: 10px;\n}\n\n.an-root .analytics-scope-label {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.an-root .analytics-scope-title {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: #9a9a9a;\n}\n\n.an-root .analytics-scope-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 12px;\n    border-radius: 999px;\n    background: rgba(81, 203, 206, .15);\n    color: #1f7f82;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.an-root .analytics-scope-breadcrumb {\n    font-weight: 400;\n    color: #3aa9ac;\n}\n\n.an-root .analytics-scope-breadcrumb::before {\n    content: \"·\";\n    margin: 0 6px 0 2px;\n}\n\n.an-root .analytics-scope-reset {\n    padding: 2px 6px;\n    font-size: 12px;\n    color: #9a9a9a;\n    text-transform: none;\n}\n\n.an-root .analytics-scope-reset:hover {\n    color: #ef8157;\n    text-decoration: none;\n}\n\n.an-root .analytics-scope-reset.is-disabled,\n.an-root .analytics-scope-reset:disabled {\n    opacity: .45;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n/* ---------- Cards ---------- */\n.an-root .card {\n    border: 1px solid #e3e3e3;\n    border-radius: 8px;\n    box-shadow: none !important;\n    margin-bottom: 0;\n}\n\n/* The outer wrapper cards only group content: keep them flat */\n.an-root .q-card-fill {\n    border: none;\n    background: transparent;\n}\n\n.an-root .q-card-fill > .card-body,\n.an-root .q-card-fill > div:first-child {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.an-root .card .card-body {\n    padding: 14px 16px;\n}\n\n.an-root .metric-number {\n    display: block;\n    font-size: 1.6rem;\n    font-weight: 700;\n    line-height: 1.2;\n    color: #252422;\n    margin-top: 4px;\n}\n\n.an-root .kpi-title { font-size: 12px; color: #9a9a9a; }\n.an-root .kpi-value { font-size: 1.6rem; font-weight: 700; color: #252422; }\n.an-root .kpi-sub { font-size: 12px; color: #9a9a9a; margin-top: 4px; }\n.an-root .section-title { font-weight: 600; margin-bottom: 8px; color: #252422; }\n\n.an-root .list-group-item {\n    padding: 8px 4px;\n    border-color: #f0f0f0;\n    font-size: 13.5px;\n    color: #252422;\n}\n\n.an-root .list-group-item strong {\n    color: #3aa9ac;\n}\n\n.an-root .form-select,\n.an-root select.form-select-sm {\n    border: 1px solid #dddddd;\n    border-radius: 6px;\n    padding: 4px 8px;\n    font-size: 13px;\n    color: #66615b;\n    background: #fff;\n}\n\n/* ---------- Selectable rows (steps, questions, skills, candidates) ---------- */\n.an-root .btn.an-item {\n    display: block;\n    margin: 0 0 6px 0 !important;\n    padding: 9px 12px;\n    text-transform: none;\n    font-size: 13.5px;\n    font-weight: 500;\n    letter-spacing: 0;\n    border-radius: 6px !important;\n    background: #fff !important;\n    color: #252422 !important;\n    border: 1px solid #ececec !important;\n    border-left: 3px solid transparent !important;\n    box-shadow: none !important;\n    white-space: normal;\n}\n\n.an-root .btn.an-item:hover,\n.an-root .btn.an-item:focus {\n    background: #f7fdfd !important;\n    border-color: #cfeff0 !important;\n}\n\n.an-root .btn.an-item.is-active {\n    background: rgba(81, 203, 206, .12) !important;\n    border-color: #51cbce !important;\n    border-left-color: #51cbce !important;\n    font-weight: 600;\n}\n\n/* ---------- Pills ---------- */\n.an-root .an-pill {\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: #f1f1f1;\n    color: #66615b;\n    white-space: nowrap;\n}\n\n.an-root .an-pill--score { background: rgba(81, 203, 206, .15); color: #1f7f82; }\n.an-root .an-pill--pending { background: #fff4d6; color: #8a6100; }\n.an-root .an-pill--approved { background: #dcf5e7; color: #1e7e4a; }\n.an-root .an-pill--rejected { background: #fde3da; color: #b3461f; }\n.an-root .an-pill--hired { background: #dff3f9; color: #1b6f87; }\n\n/* Bootstrap-5 style badges used in a few places */\n.an-root .badge.bg-success { background: #6bd098 !important; }\n.an-root .badge.bg-secondary { background: #fbc658 !important; color: #5c4400 !important; }\n\n/* ---------- Empty states ---------- */\n.an-root .an-empty {\n    text-align: center;\n    color: #9a9a9a;\n    padding: 28px 12px;\n    font-size: 13px;\n    border: 1px dashed #dddddd;\n    border-radius: 8px;\n}\n\n/* ---------- Utilities used by the sub-tabs ---------- */\n.an-root .gap-8 { gap: 8px; }\n.an-root .gap-12 { gap: 12px; }\n.an-root .mb-6 { margin-bottom: 6px; }\n.an-root .fs-10 { font-size: 10px; }\n.an-root .fs-12 { font-size: 12px; }\n.an-root .fw-600 { font-weight: 600; }\n.an-root .fw-700 { font-weight: 700; }\n.an-root .op-60 { opacity: .6; }\n.an-root .op-70 { opacity: .7; }\n\n/* ---------- CandidatesTab ---------- */\n.an-root .ct-card-body { display: flex; flex-direction: column; gap: 12px; height: 100%; }\n.an-root .cand-list {\n    max-height: 320px;\n    overflow: auto;\n    border: 1px solid #f0f0f0;\n    border-radius: 8px;\n    padding: 8px;\n}\n\n/* ---------- Histogram (class-based variant) ---------- */\n.an-root .hist-wrap { height: 150px; display: flex; align-items: flex-end; gap: 8px; padding: 8px 4px; }\n.an-root .hist-col { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px; }\n.an-root .hist-bar-container { width: 100%; height: 120px; display: flex; align-items: flex-end; }\n.an-root .hist-bar {\n    width: 100%;\n    height: var(--h, 0%);\n    background: #51cbce;\n    border-radius: 4px;\n    transition: height .3s ease;\n}\n.an-root .hist-label { font-size: 10px; white-space: nowrap; }\n\n/* ---------- DepartmentsSidebar ---------- */\n.an-root .sidebar-header-title { font-weight: 600; }\n.an-root .sidebar-stack { display: flex; flex-direction: column; gap: 8px; }\n.an-root .sidebar-btn { border-radius: 6px; }\n\n/* ---------- Selectable list (SkillsTab) ---------- */\n.an-root .selectable-list .list-group-item {\n    border: 1px solid #ececec;\n    margin-bottom: 6px;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    transition: background .15s ease;\n}\n.an-root .selectable-list .list-group-item:hover { background: #f7fdfd; }\n.an-root .selectable-list .list-group-item.active {\n    background: rgba(81, 203, 206, .12) !important;\n    border-color: #51cbce !important;\n    color: #252422 !important;\n    font-weight: 600;\n}\n\n/* Bootstrap 4 has no \"g-3\" gutters: give the card grids vertical spacing */\n.an-root .row.g-3 > [class*=\"col\"] {\n    margin-bottom: 16px;\n}\n\n/* KPI labels never break inside a word */\n.an-root .card-body > div:first-child {\n    overflow-wrap: normal;\n    word-break: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
